<template>
  <v-row >

    <v-col v-if="colextra==false" cols-12 md-6 >
      <!-- {{modelValue}} -->
      <!--div class="my-2">  
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
      </div-->

      
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 400px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 200px; " class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'det_name'" @update:model-value="getLegName" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 200px; " class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'det_date'" @update:model-value="getYearAndMonth" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
      </v-sheet>





      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'location'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'coordinates'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'precision'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'depth_zone'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'mesh_size'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>

        <v-sheet style="min-width: 100px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'alt'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>

      </v-sheet>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'leg_number'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'leg_name'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'leg_date'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'year'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 200px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'month'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
      </v-sheet>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'pictures'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'comments'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>

      <h2 class="text-regularlight" >Main Page</h2>   
    </v-col>
<!--dialogextra columns-->
<v-col v-if="colextra==true" cols-12 md-6>

    <v-sheet v-if="dialogmainbiology==true" class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('mainbiology')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>

    <v-sheet v-if="dialogmorphology==true" class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('morphology')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>

    <v-sheet v-if="dialogpathologies==true" class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('pathologies')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>
<!---->
    <v-sheet v-if="dialogfoodcomposition==true" class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('food_composition')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>

    <v-sheet v-if="dialogchemistry==true" class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('chemistry')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>

    <v-btn 
      class="my-1 ma-2"
      color="regular"
      variant="outlined"
      @click="tabname='Main page', colextra=false, dialogmainbiology = false, dialogmorphology = false, dialogpathologies = false, dialogfoodcomposition=false, dialogchemistry=false"
      size="x-large"
    >Close {{tabname}}
    </v-btn>


  
</v-col>
<!--end extra columns-->

  <!--end of first column-->
    <v-col  cols-12 md-6 style="min-width: 300px; max-width: 350px">
      <div class="my-2">
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'store_species'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
      </div>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'main_storage'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>    	
      <!--div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'current_storage'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </!--div> 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'localcollnumber'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>    	 -->


          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'leg_number'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>

  <!-- extradata: -->
        <!-- <v-btn
        @click="dialogmainbiology=!dialogmainbiology" 
          class="my-1"
          variant="flat"
          color="regular"
          >Main biology
        </v-btn><br> -->
        <v-btn
        v-if="colextra==true"
        @click="tabname='Main page', colextra=false, dialogmainbiology=false, dialogfoodcomposition=false, dialogchemistry=false, dialogpathologies=false, dialogmorphology=false" 
          class="my-1"
          variant="flat"
          color="regularlight"
          >Main page
        </v-btn><br>

        <v-btn
        v-if="dialogmainbiology==false"
        @click="colextra=true, dialogmainbiology=true, dialogfoodcomposition=false, dialogchemistry=false, dialogmorphology=false, tabname='Main biology'" 
          class="my-1"
          variant="flat"
          color="regular"
          >Main biology
        </v-btn><br>

        <v-btn
        v-if="dialogmorphology==false"
        @click="colextra=true, dialogmorphology=true, dialogfoodcomposition=false, dialogchemistry=false, dialogmainbiology=false, dialogpathologies=false, tabname='Morphology'" 
          class="my-1"
          variant="flat"
          color="regular"
          >Morphology
        </v-btn><br>
        <v-btn
        v-if="dialogpathologies==false"
        @click="colextra=true, dialogpathologies=true, dialogfoodcomposition=false, dialogchemistry=false, dialogmorphology=false, dialogmainbiology=false, tabname='Pathologies'" 
          class="my-1"
          variant="flat"
          color="regular"
          >Pathologies
        </v-btn><br>

        <v-btn
        v-if="dialogfoodcomposition==false"
        @click="colextra=true, dialogfoodcomposition=true, dialogchemistry=false, dialogpathologies=false, dialogmorphology=false, dialogmainbiology=false, tabname='Food composition'" 
          class="my-1"
          variant="flat"
          color="regular"
          >Food composition
        </v-btn><br>
        <v-btn
        v-if="dialogchemistry==false"
        @click="colextra=true, dialogchemistry=true, dialogfoodcomposition=false, dialogpathologies=false, dialogmorphology=false, dialogmainbiology=false, tabname='Chemistry'" 
          class="my-1"
          variant="flat"
          color="regular"
          >Chemistry
        </v-btn><br>  

      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'locationexcluded'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
    </v-col>
  </v-row>


</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'StandardBaseFormT',
    components: {

},

data(){ 
    return {
      dialogmainbiology: false,
      dialogmorphology: false,
      dialogpathologies: false,
      dialogfoodcomposition: false,
      dialogchemistry: false,
      colextra: false,
    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],
methods: {
  // col in meta.columns

  getYearAndMonth(value) {

    if (value !== null){
      this.curentRow['leg_date'] = value;
      this.curentRow['year'] = +value.split('-')[0];
      this.curentRow['month'] = +value.split('-')[1];
    }

  },

  getLegName(value){
//console.log(value);
    if (value !== null){
      this.curentRow['leg_name'] = value;
    }

  },
  


},

computed: {

getColumn() {
},

},

  mounted(){

  },

})
</script>